import { render, staticRenderFns } from "./bairong.vue?vue&type=template&id=19c4a71e&scoped=true"
import script from "./bairong.vue?vue&type=script&lang=js"
export * from "./bairong.vue?vue&type=script&lang=js"
import style0 from "./bairong.vue?vue&type=style&index=0&id=19c4a71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4a71e",
  null
  
)

export default component.exports